import "../styles/sectionHeading.css";
const SectionHeading = ({ children }) => {
  return <h2>{children}</h2>;
};
export default SectionHeading;
